import api from './api';

const organizerService = {
  getDashboard: () => api.get('/organizer/dashboard'),
  getProfile: () => api.get('/organizer/profile'),
  updateProfile: (data) => api.put('/organizer/profile', data),
  
  // Events
  getEvents: () => api.get('/organizer/events'),
  createEvent: (data) => api.post('/organizer/events', data),
  getEvent: (id) => api.get(`/organizer/events/${id}`),
  updateEvent: (id, data) => api.put(`/organizer/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/organizer/events/${id}`),
  uploadEventImages: (id, formData) => api.post(`/organizer/events/${id}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getEventSales: (id) => api.get(`/organizer/events/${id}/sales`),
  getEventAttendees: (id) => api.get(`/organizer/events/${id}/attendees`),
  
  // Ticket Categories
  createTicketCategory: (data) => api.post('/organizer/ticket-categories', data),
  updateTicketCategory: (id, data) => api.put(`/organizer/ticket-categories/${id}`, data),
  deleteTicketCategory: (id) => api.delete(`/organizer/ticket-categories/${id}`),
  
  // Agents
  getAgents: () => api.get('/organizer/agents'),
  createAgent: (data) => api.post('/organizer/agents', data),
  updateAgent: (id, data) => api.put(`/organizer/agents/${id}`, data),
  deleteAgent: (id) => api.delete(`/organizer/agents/${id}`),
  assignAgentToEvent: (id, data) => api.post(`/organizer/agents/${id}/assign`, data),
  
  // Gates
  createGate: (data) => api.post('/organizer/gates', data),
  updateGate: (id, data) => api.put(`/organizer/gates/${id}`, data),
  deleteGate: (id) => api.delete(`/organizer/gates/${id}`),
  
  // Notifications
  sendNotification: (data) => api.post('/organizer/notifications', data),
  getNotifications: () => api.get('/organizer/notifications'),
  
  // Financial
  getWallet: () => api.get('/organizer/financial/wallet'),
  requestWalletDump: (data) => api.post('/organizer/financial/wallet/request-dump', data),
  
  // Addons
  getAddons: () => api.get('/organizer/addons'),
  purchaseAddon: (data) => api.post('/organizer/addons/purchase', data),
};

export default organizerService;

